import {
  LuX,
} from 'react-icons/lu';

// Rótulos e cores compartilhados pelas telas do Módulo de Treinamentos.

export const COURSE_STATUS = {
  draft:     { label: 'Rascunho',  bg: 'var(--surface-3)', color: 'var(--text-2)' },
  published: { label: 'Publicado', bg: 'var(--success-soft)', color: 'var(--success)' },
  archived:  { label: 'Arquivado', bg: 'var(--warning-soft)', color: 'var(--warning)' },
};

export const ENROLLMENT_STATUS = {
  in_progress: { label: 'Em andamento', bg: 'var(--info-soft)', color: 'var(--info)' },
  approved:    { label: 'Aprovado',     bg: 'var(--success-soft)', color: 'var(--success)' },
  failed:      { label: 'Reprovado',    bg: 'var(--danger-soft)', color: 'var(--danger)' },
};

export const LESSON_TYPES = {
  video:      'Vídeo',
  text:       'Texto',
  video_text: 'Vídeo + texto',
};

export const QUESTION_TYPES = {
  single:     'Escolha única',
  multiple:   'Múltipla escolha',
  true_false: 'Verdadeiro/Falso',
};

// Mesmo padrão semáforo do sistema: verde ≥ 80, amarelo 60–79, vermelho < 60.
export const SEMAFORO = {
  verde:    { label: 'Verde',    bg: 'var(--success-soft)', color: 'var(--success)', dot: 'var(--success)' },
  amarelo:  { label: 'Amarelo',  bg: 'var(--warning-soft)', color: 'var(--warning)', dot: 'var(--warning)' },
  vermelho: { label: 'Vermelho', bg: 'var(--danger-soft)', color: 'var(--danger)', dot: 'var(--danger)' },
};

export const errorMessage = (e, fallback = 'Erro ao salvar') => e?.response?.data?.error || fallback;

export function Badge({ meta }) {
  if (!meta) return null;
  return <span className="training-badge" style={{ background: meta.bg, color: meta.color }}>{meta.label}</span>;
}

/** Casca padrão de modal do projeto (mesmo visual de HolidaysPage/EmployeesPage). */
export function Modal({ title, icon, onClose, children, maxWidth = 560 }) {
  return (
    <div className="training-modal-overlay">
      <div className="training-modal" style={{ maxWidth }}>
        <div className="training-modal-header">
          <div className="training-modal-title">{icon}{title}</div>
          <button type="button" onClick={onClose} className="training-icon-btn" aria-label="Fechar">
            <LuX size={17} />
          </button>
        </div>
        <div className="training-modal-body">{children}</div>
      </div>
    </div>
  );
}

export const readFileAsDataUrl = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(reader.result);
  reader.onerror = () => reject(new Error('Não foi possível ler o arquivo.'));
  reader.readAsDataURL(file);
});

/** Reduz a imagem (lado maior até `maxSide`) e converte para JPEG — capa e imagens do texto ficam leves. */
export const resizeImageFile = (file, maxSide = 1200, quality = 0.82) => new Promise((resolve, reject) => {
  const img = new Image();
  const url = URL.createObjectURL(file);
  img.onload = () => {
    const scale = Math.min(1, maxSide / Math.max(img.width, img.height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(img.width * scale);
    canvas.height = Math.round(img.height * scale);
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    URL.revokeObjectURL(url);
    resolve(canvas.toDataURL('image/jpeg', quality));
  };
  img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('Imagem inválida.')); };
  img.src = url;
});

export const fmtDate = (v) => (v ? new Date(String(v).length === 10 ? `${v}T12:00:00` : v).toLocaleDateString('pt-BR') : '—');
export const fmtScore = (v) => (v === null || v === undefined ? '—' : Number(v).toLocaleString('pt-BR', { maximumFractionDigits: 2 }));

/** Converte links comuns (YouTube/Vimeo) para o endereço de incorporação; demais links tocam como vídeo direto. */
export const embedUrl = (url) => {
  if (!url) return null;
  const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/i);
  if (yt) return { type: 'iframe', src: `https://www.youtube.com/embed/${yt[1]}` };
  const vimeo = url.match(/vimeo\.com\/(?:video\/)?(\d+)/i);
  if (vimeo) return { type: 'iframe', src: `https://player.vimeo.com/video/${vimeo[1]}` };
  return { type: 'video', src: url };
};

/** Baixa um arquivo a partir de data URL ou link. */
export const downloadFile = (url, name) => {
  const a = document.createElement('a');
  a.href = url;
  a.download = name || 'arquivo';
  a.target = '_blank';
  a.rel = 'noopener noreferrer';
  document.body.appendChild(a);
  a.click();
  a.remove();
};

/** "mm:ss" (ou "h:mm:ss") para o cronômetro da avaliação. */
export const fmtClock = (totalSeconds) => {
  const s = Math.max(0, Math.floor(totalSeconds));
  const h = Math.floor(s / 3600);
  const mm = String(Math.floor((s % 3600) / 60)).padStart(2, '0');
  const ss = String(s % 60).padStart(2, '0');
  return h ? `${h}:${mm}:${ss}` : `${mm}:${ss}`;
};
